import { useState } from "react";
import { KeyRound, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UnlockHistory } from "@/components/UnlockHistory";
import { UnlockDoorButton } from "@/components/UnlockDoorButton";

export const DoorCode = ({ booking, canManage, onChange, testid }) => {
  const [busy, setBusy] = useState(false);
  const { admin } = useAuth();
  const isSuper = admin?.role === "super_admin";
  if (booking.payment_status !== "paid" || booking.status === "cancelled") return null;
  const issue = async () => {
    setBusy(true);
    try { const r = await api.post(`/admin/bookings/${booking.id}/door-code`); toast.success(`New door code: ${r.data.door_code}`); onChange?.(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <span className="text-xs flex flex-wrap items-center gap-x-2 gap-y-1.5 text-white/60" data-testid={testid}>
      <KeyRound size={13} className="text-[#D4AF37]" />
      {booking.door_code ? <>Door code <b className="text-[#D4AF37] tracking-[0.2em]" data-testid={`${testid}-value`}>{booking.door_code}</b></> : <span className="text-white/40">No door code</span>}
      {canManage && (
        <button onClick={issue} disabled={busy} title={booking.door_code ? "Replace with a new code" : "Create door code"} data-testid={`${testid}-issue`}
          className="text-white/40 hover:text-[#D4AF37] disabled:opacity-40"><RefreshCw size={12} className={busy ? "animate-spin" : ""} /></button>
      )}
      <UnlockHistory bookingId={booking.id} testid={`${testid}-history`} />
      {isSuper && <UnlockDoorButton bookingId={booking.id} compact label="Unlock" testid={`${testid}-unlock`} />}
    </span>
  );
};
